import {
  faCircle,
  faEdit,
  faPlus,
  faArrowRight,
  faRemove,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { EventType } from 'src/gql/graphql';

// Get icon for event type
export const getEventIcon = (eventType?: EventType): IconDefinition => {
  switch (eventType) {
    case EventType.Deleted:
      return faRemove;
    case EventType.Created:
      return faPlus;
    case EventType.Modified:
      return faEdit;
    case EventType.Duplicated:
      return faArrowRight;
    default:
      return faCircle;
  }
};

// Helper to check if a range includes an index
export const isIndexInRange = (
  index: number,
  range: [number, number]
): boolean => {
  return index >= range[0] && index < range[1];
};

// Helper to determine if an event is first or last in a range
export const getEventRangePosition = (
  index: number,
  range: [number, number]
) => {
  const isFirst = index === range[0];
  const isLast = index === range[1] - 1;

  return { isFirst, isLast };
};
